<template>
  <div id="redirect"></div>
</template>

<script>
export default {
  name: "redirect",
  data(){
    return{
      dataObjectUrl:''
    }
  }
  ,
  created(){
    this.upload_callback();
  },
  methods:{
    getUrlVars(url) {
      var hash;
      var myJson = {};
      var hashes = url.slice(url.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
      }
      return myJson;
    },
    getParameter() {
      // 获取到重定向发送过来的信息
      var uri = decodeURI(window.document.location.href);
      //有%3A之类的乱码，需要用正则处理一下
      uri = uri.replace(/%3A/g, ":").replace(/%2F/g, "/").replace(/%3F/g, "?").replace(/%3D/g, "=").replace(/%26/g, "&");
      var query = uri.substring(uri.indexOf('?')+1)
      return this.getUrlVars(query)
    },
    upload_callback() {
      var obj = this.getParameter();
      //这里是对数据处理之后，走完这个js会回到kindeditor的js中，继续执行，注意如果后台返回了url,但是弹窗提醒是undef，
      // 可能是因为，自己这边传递接受的error的值不是number类型
      // ，为kindeditor源码里面对error的值的判断都是用的全等，值和类型都相等的情况
      obj.error = parseInt(obj.error)
      var data = JSON.stringify(obj)
      document.getElementsByTagName("body")[0].innerHTML = '<pre>' + data + '</pre>';
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/common/Redirect.vue